import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

import SubHeading from "../../../../../../components/common/SubHeading";
import WarningMessage from "../../../../../../components/common/WarningMessage";
import AttachmentsUpload from "../../../../../../components/common/AttachmentsUpload";
import MultiSelect from "../../../../../../components/common/MultiSelect";

import {
  attachments,
  leasTemplates,
  templates,
} from "../../../../../../data/attachments";

import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Space,
  Table,
} from "antd";
import { useDispatch } from "react-redux";
import { useForm } from "antd/lib/form/Form";
import { toast } from "react-hot-toast";
import { setGenerateLease } from "../../../../../../store/moveInTenantSlice";

const message = (
  <p>
    No PDF form templates have been set up yet.{" "}
    <span className="onclick-text">Add a new PDF form template</span> to
    continue generating an online lease or skip this step for later.
  </p>
);

function GenerateLease({ current, setCurrent }) {
  const [value, setValue] = useState(1);
  const [clicked, setClicked] = useState(false);
  const [sortedInfo, setSortedInfo] = useState({});
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [templateValue, setTemplateValue] = useState("");
  const [disabled, setDisabled] = useState(true);
  const [checked, setChecked] = useState(true);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = useForm();

  const next = () => {
    setCurrent(current + 1);
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const selectChange = (value) => {
    setTemplateValue(value);
    setDisabled(false);
  };

  const onChange = (e) => {
    console.log("radio checked", e.target.value);
    setValue(e.target.value);
  };

  const onSelectChange = (newSelectedRowKeys) => {
    console.log("selectedRowKeys changed: ", newSelectedRowKeys);
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };

  const handleChange = (pagination, filters, sorter) => {
    console.log("Various parameters", pagination, filters, sorter);
    setSortedInfo(sorter);
  };
  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      render: (text) => <span className="onclick-text">{text}</span>,
      sorter: (a, b) => a.name.length - b.name.length,
      sortOrder: sortedInfo.columnKey === "name" ? sortedInfo.order : null,
      ellipsis: true,
    },
    {
      title: "Upload On",
      dataIndex: "uploadOn",
      key: "uploadOn",
      sorter: (a, b) => a.uploadOn.length - b.uploadOn.length,
      sortOrder: sortedInfo.columnKey === "uploadOn" ? sortedInfo.order : null,
      ellipsis: true,
    },
  ];

  const handleFormSubmit = () => {
    form
      .validateFields()
      .then(() => {
        const formData = form.getFieldsValue();
        Object.keys(formData).forEach((field) => {
          if (formData[field] === undefined) {
            formData[field] = "";
          }
        });
        dispatch(setGenerateLease({generateLeaseMethod: formData.generateLeaseMethod}));
        next();
      })
      .catch((errorInfo) => {
        console.log("Validation Errors:", errorInfo.errorFields);
      });
  };
  const onFinishFailed = (errorInfo) => {
    toast.error("There are problems with one or more required fields");
    console.log("Failed:", errorInfo);
  };
  return (
    <div className="profile">
      <SubHeading subHeading="Generate Lease" />
      <Form
        onFinish={handleFormSubmit}
        onFinishFailed={onFinishFailed}
        form={form}
      >
        <Row gutter={[0, 16]}>
          <Col span={24}>
            <WarningMessage message="A screening report is not detected for this tenant." />
          </Col>
          <Col span={24}>
            <Form.Item name="generateLeaseMethod">
              <Radio.Group onChange={onChange} value={value}>
                <Space direction="vertical">
                  <Radio value={1}>Generate Lease with Lease Templates</Radio>
                  <Radio value={2}>
                    Generate Lease with PDF Form Templates
                  </Radio>
                  <Radio value={3}>Upload Fully Executed Lease</Radio>
                </Space>
              </Radio.Group>
            </Form.Item>
          </Col>
          {clicked && value === 1 ? (
            <Row gutter={[0, 24]}>
              <Col span={24}>
                <p>Choose Template</p>
                <Form.Item name="templateName">
                  <Select
                    options={templates}
                    placeholder="Choose Template"
                    onChange={selectChange}
                  />
                </Form.Item>
              </Col>
              <Col span={24}>
                <p>Select Addenda</p>
                <p>
                  You may select multiple addenda to include with your lease by
                  choosing each addendum from the list one at a time.
                </p>
                <MultiSelect
                  placeholder="Select..."
                  options={leasTemplates}
                  name="addendaTemplates"
                />
              </Col>
              <Col span={24}>
                <p>Select Attachments</p>
                <div className="table-container">
                  <Table
                    className="card-container"
                    columns={columns}
                    dataSource={attachments}
                    onChange={handleChange}
                    rowSelection={rowSelection}
                    rowKey={(obj) => obj.id}
                  />
                </div>
              </Col>
              {templateValue === "" ? null : (
                <Col span={24}>
                  <p>Enter Values for Manual Fields</p>
                  <Form layout="vertical">
                    <Form.Item label="Garage Remotes" name="garageRemotes">
                      <Input />
                    </Form.Item>
                  </Form>
                </Col>
              )}
              <br />
              <Col span={24}>
                <Button disabled={disabled} type="primary">
                  Prepare Lease
                </Button>
              </Col>
            </Row>
          ) : (
            <>
              {value === 3 ? (
                <Col span={24}>
                  <Row>
                    <Col span={24}>
                      <p>
                        This lease requires the tenant to demonstrate proof of
                        liability insurance for at least $100,000.
                      </p>
                    </Col>
                    <Col span={24}>
                      {/* <AttachmentsUpload /> */}
                    </Col>
                    <Col span={24}>
                      <Button type="primary">
                        Upload and Mark as Fully Executed
                      </Button>
                    </Col>
                  </Row>
                </Col>
              ) : null}
              {value === 3 || (value === 2 && clicked) ? null : (
                <Col span={24}>
                  <WarningMessage message="One or more email addresses are missing. Emails are required for tenants to access the Online Portal. You may still continue to generate a lease and print it for your tenants to sign." />
                </Col>
              )}
              <Col span={24}>
                {value === 3 || (value === 2 && clicked) ? null : (
                  <Button type="primary" onClick={() => setClicked(true)}>
                    Continue Without Emails
                  </Button>
                )}
              </Col>
            </>
          )}
          {clicked && value === 2 ? (
            <Col span={24}>
              <WarningMessage message={message} />
            </Col>
          ) : null}
          <Col span={24}>
            <Row>
              <Col span={5}>
                <span>Insurance Requirement</span>
              </Col>
              <Col span={1}>
                <Form.Item name="insuranceRequirement">
                  <Checkbox
                    checked={checked}
                    onChange={() => setChecked(!checked)}
                  ></Checkbox>
                </Form.Item>
              </Col>
              <Col span={18}>
                <span>
                  This lease requires the tenant to demonstrate proof of
                  liability insurance for at least $100,000.
                </span>
              </Col>
            </Row>
          </Col>
          {!checked ? (
            <Col span={24}>
              <WarningMessage message="Unchecking this box indicates that you do not have a lease requirement for this unit to obtain $100,000 in liability coverage. It will not be eligible for Smart LLI Enrollment. If you require liability coverage for some units and not others, you may be at risk." />
            </Col>
          ) : null}
          <Col span={24}>
            <Row gutter={[8, 0]} justify="end">
              <Col>
                <Button type="primary" htmlType="submit">
                  Skip This Step
                </Button>
              </Col>
              <Col>
                <Button onClick={() => prev()}>Previous</Button>
              </Col>
              <Col>
                <Button type="link" onClick={() => navigate("/")}>
                  Cancel Move In
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default GenerateLease;
